import { render, staticRenderFns } from "./ActivePostDoc.vue?vue&type=template&id=4e9547e7&"
import script from "./ActivePostDoc.vue?vue&type=script&lang=js&"
export * from "./ActivePostDoc.vue?vue&type=script&lang=js&"
import style0 from "./ActivePostDoc.vue?vue&type=style&index=0&id=4e9547e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports